import type { FaireProductEntity } from "../../entity_types/product";

export const p_kb774ksdrr: FaireProductEntity = {
  token: "p_kb774ksdrr",
  type: "product",
  name: "Neon Worms",
  brandToken: "b_dkshdskwmr",
  brandName: "King Henry's",
  imageUrl:
    "https://cdn.faire.com/fastly/d435be6502d945b24f5fe20bc077a888e73752ae58b2aeb097aeb16277a4c4eb.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.52,
  description:
    "Indulge in the delight of King Henry's Neon Worms, a playful treat that will tantalize your taste buds. As a part of our gummy collection, these Neon Worms offer a burst of flavor that's hard to resist. King Henry's, a woman-owned national snack company, has been committed to providing high-quality, value-for-money snacks for over 30 years. Enjoy the tradition of excellence and variety that we bring to your snack time. Please note, packaging dimensions are 11 7/16 x 9 7/16 x 3 1/2.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:15.087Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
